<template>
  <div class="modal-drag-custom-drag limit-height-size" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			:resizable="false"
			height="auto"
			width="90%"
			:maxWidth="900"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center justify-space-between flex-1">
							<div class="d-flex align-center">
								<v-icon color="white" small class="info-icon mr-2">mdi-briefcase-outline</v-icon>
								<p class="mb-0 font-weight-bold text-primary title">{{contractType}}</p>
							</div>
							<div class="d-flex align-center justify-end" style="gap: 5px;" v-if="contract">
								<div v-if="contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES">
									<v-menu offset-y>
										<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-btn
														outlined
														color="#959595"
														dark
														small
														v-bind="{ ...menuAttrs, ...tooltipAttrs }"
														v-on="{ ...menuOn, ...tooltipOn }"
													>
														<div class="d-flex flex-row align-center">
															<v-icon small class="mr-2">mdi-briefcase-plus-outline</v-icon>
															<p class="mb-0 caption">Anexos de Contrato</p>
														</div>
													</v-btn>
												</template>
												<span>Anexos de Contrato</span>
											</v-tooltip>
										</template>
										<v-list dense class="py-0">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<div class="d-flex justify-space-between align-center w-100">
													<p class="caption mb-0 font-weight-bold white--text">Anexos de Contrato</p>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon
																color="white"
																dark
																class="mb-0"
																small
																@click="startContractAddendum"
																v-if="$checkPermissions(['edit_contracts'])"
																v-bind="attrs"
																v-on="on"
															>
																<v-icon small>mdi-plus</v-icon>
															</v-btn>
														</template>
														<span>Crear anexo de contrato</span>
													</v-tooltip>
												</div>
											</v-list-item>
											<v-list-item-group color="#524D4D" v-if="contractAddendums.length">
												<v-list-item
													v-for="(addendum, index) in contractAddendums"
													:key="'ass-'+index"
													dense
													@click="$store.commit('contracts/setContractAddendumModalId', addendum.id)"
													style="min-width: 200px"
												>
													<v-list-item-title dense>
														<div class="d-flex justify-space-between align-center item-background-hover">
															<div class="d-flex justify-space-between caption" style="width: 100%">
																<div style="width: 90px">Ir a Anexo</div>
																<b class="text-end" style="flex: 1;">#{{index + 1}}</b>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
											<v-list-item v-else>
												<div class="d-flex justify-center align-center caption">
													<p class="mb-0">No hay anexos asociados a este contrato</p>
												</div>
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
								<div v-if="contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												outlined
												color="#959595"
												dark
												small
												@click="startAddendumRequest"
												v-bind="attrs"
												v-on="on"
											>
												<div class="d-flex flex-row align-center">
													<v-icon small class="mr-2">mdi-briefcase-plus-outline</v-icon>
													<p class="mb-0 caption">Solicitar Anexo de Contrato</p>
												</div>
											</v-btn>
										</template>
										<span>Solicitar Anexo de Contrato</span>
									</v-tooltip>
								</div>
								<div>
									<AdditionalRequirementsMenu
										v-if="project"
										:contract="contractInfo"
										:project="project"
									/>
								</div>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-4">
					<NonEditableContract :contract_id="$store.state.contracts.contractModalId" @contractInfo="handleContractInfo" v-if="isClient"/>
					<ClientContract :contract_id="$store.state.contracts.contractModalId" @contractInfo="handleContractInfo" v-else/>
				</v-card-text>
			</v-card>
		</modal>
	</div>
</template>

<script>
import NonEditableContract from '@/components/Views/Contracts/NonEditableContract'
import ClientContract from '@/components/Views/Clients/Parts/Contracts/ClientContract'
import AdditionalRequirementsMenu from '@/components/Views/Projects/Requirements/AdditionalRequirementsMenu'
import { addContractAddendum } from '@/helpers/api/contracts'
import contractStatuses from '@/components/Helpers/Constants/contract.js'

export default {
	name: 'ClientsContractModal',
  components: { NonEditableContract, ClientContract, AdditionalRequirementsMenu },
  data() {
    return {
			contractStatuses,
			indexModal: + new Date(),
			contractInfo: null
    };
  },
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		contract(){
			return this.$store.state.contracts.contractModalInfo
		},
		contractAddendums(){
			return this.contract?.addendums || []
		},
		contractType(){
			let contractType = 'Contrato'
			if(this.contract?.addendum_to_contract_id){
				contractType = 'Anexo de Contrato'
			}
			else if(this.contract?.subcontract_to_contract_id){
				contractType = 'Subcontrato'
			}
			return contractType
		},
		partContractType(){
			return this.contract.subcontract_to_contract_id ? 'Subcontratista' : 'Cliente'
		},
		project(){
			console.log('Computing project from contractInfo: ', this.contractInfo) // Debug log
			return this.contractInfo?.morphable || null
		}
  },
	watch:{
		contract(newValue){
			if(newValue){
				this.$store.commit('contracts/setContractModalInfo', this.contract)
			}
		}
	},
	mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
	},
	beforeDestroy(){
		this.$store.commit('contracts/setContractModalId', false)
	},
  methods: {
		startAddendumRequest(){
			const data = {
				project_line_id: this.contract?.morphable?.associations?.project_line_id,
				project_name: this.contract?.morphable?.name,
				request_type: 4
			}
			this.$store.commit('userrequests/setNewRequestModalInfo', data)
			this.$store.commit('userrequests/setNewRequestModal', true)
		},
    closeModal(){
			this.$store.commit('contracts/setContractModalId', false)
    },
		async startContractAddendum(){
			const confirmed = await confirm('¿Estás seguro de que deseas crear un nuevo anexo para este contrato?')
			if(confirmed){
				this.createContractAddendum()
			}
		},
		handleContractInfo(contract){
			console.log('Contract info received in modal: ', contract) // Debug log
			this.contractInfo = contract
		},
		async createContractAddendum(){
			const data = {
				contract_id: this.contract.id
			}
			const addendum = await addContractAddendum(data)
			if(addendum.code == 200){
				this.closeModal()
				this.$router.push({ name: 'ContractAddendumDetail', query: { id: addendum.contract_addendum.id } })
				const messageData = {
					message: 'Se ha creado correctamente el anexo.',
					title: 'Anexo Creado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
  },
};
</script>

<style scoped>
	.client-items-container{
		border: 1px solid rgb(213, 211, 211);
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.vertical-tabs .rotated-tab {
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		text-align: center;
		height: 150px;
		line-height: 1;
	}

	.vertical-tabs .v-tab {
		justify-content: center;
		align-items: center;
		min-height: 100px;
		padding: 0px;
		min-width: 40px;
		width: 40px;
		font-size: 12px;
	}
	.vertical-tabs {
		align-items: flex-start;
		height: 100%;
	}
	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	.change-col-size{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
	.tab-item-custom .v-window__container{height: auto;}
</style>